import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";

export class ProfileUpdateCustomRequest {
  public static readonly CustomProcessRequestType: string = "profile_update_custom_request";

  public id: number = 0;
  public personal_info_id: number = 0;
  public honorific: number = 0;
  public first_name: string = '';
  public middle_name: string = '';
  public last_name: string = '';
  public first_name_mr: string = '';
  public middle_name_mr: string = '';
  public last_name_mr: string = '';
  public email_id: string = '';
  public mobile_no: string = '';
  public profile_pic_path: string = '';
  public source_table: string = '';

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, ProfileUpdateCustomRequest.CustomProcessRequestType) as DataCollection;
    coll.Entries.push(this);
  }

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.CustomProcess);
    this.MergeIntoTransportData(td);

    return td;
  }
}
